export default {
  "cod100": "Please, introduce the entity code.",
  "cod101": "The entity code has not been found in the database.",
  "cod102": "The combination entity code and source of information already exist in the file.",
  "cod199": "An error has occurred when charging the file, it was not possible to create a new entity in the platform.",
  "cod200": "Please, introduce the information source code.",
  "cod201": "The information source code already exists in the database.",
  "cod300": "Please, introduce the information source.",
  "cod301": "The information source was not found in the database.",
  "cod302": "The information source was not found in the database.",
  "cod305": "The user could not be updated. The password and its confirmation do not match.",
  "cod310": "The user could not be updated. The password does not meet the required format.",
  "cod311": "The user could not be updated. The current password does not match the one for the logged-in user.",
  "cod400": "Please, introduce the entity code.",
  "cod401": "The code has not been found in the database.",
  "cod402": "The code already exists in the file.",
  "cod403": "The code already exists in the database.",
  "cod404": "The code already exists in the database but was discharged.",
  "cod500": "Please, introduce the name of the entity.",
  "cod600": "Please, select at least one item from this category.",
  "cod601": "The item from this category has not been found in the database.",
  "cod602": "The item or items cannot be assigned because they no longer belong to the identified user in the system. (when creating and editing a user)",
  "cod603": "It is not possible to assign these categories. These category items do not belong to the identified user in the system.",
  "cod700": "Please, introduce the geo-zone polygon.",
  "cod701": "Error when creating the polygon",
  "cod800": "The entity’s ID is required.",
  "cod801": "The entity’s Id was not found in the database.",
  "cod802": "The combination of the entity’s ID and the information source already exists in the file.",
  "cod803": "The combination of the entity’s ID and the information source already exists in the file.",
  "cod900": "The unknown entity’s ID is required.",
  "cod901": "The unknown entity’s ID was not found in the database.",
  "cod994": "You cannot activate yourself in the platform as a safety measure.",
  "cod995": "You cannot deactivate yourself in the platform as a safety measure.",
  "cod999": "Error in the file",
  "cod1000": "ID is required",
  "cod1001": "The ID has not been found in the database.",
  "cod1002": "The ID already exists in the file.",
  "cod1003": "The Id already exists in the database.",
  "cod1004": "The ID already exists in the database but was discharged.",
  "cod1100": "Please, introduce the starting date.",
  "cod1200": "Please, write an email",
  "cod1201": "The e-mail (username) has not been found.",
  "cod1202": "The e-mail (username)already exists in the users list you wish to save or update.",
  "cod1203": "The e-mail (username) already exists in the database.",
  "cod1204": "The e-mail (username) already exists in the database but was discharged.",
  "cod1205": "The written email has an invalid format.",
  "cod1300": "The password is required.",
  "cod1301": "Re-write your password.",
  "cod1302": "Passwords are required.",
  "cod1303": "Passwords do not match.",
  "cod1400": "Please, add a name.",
  "cod1500": "Please, add at least one permit.",
  "cod1501": "Permit not found in the system.",
  "cod1502": "Permit not found in the system.",
  "cod1600": "Please, indicate if the user is an administrator.",
  "cod6500": "File cannot be open, sudden error.",
  "cod6501": "File data could not be loaded. (the params attribute of the answer in a JSON format will be found the details).",
  "cod6502": "File cannot open, No se pudo leer el archivo, incompatible front.",
  "cod6503": "Please, load the file.",
  "cod6504": "Please, write the required data in the file.",
  "cod6505": "There is no sheet with the date in the file",
  "cod9000": "The user have no available permits.",
  "cod9100": "You cannot edit yourself as a safety measure.",
  "cod10001": "Vehicle field required.",
  "cod10002": "Driver field required.",
  "cod10003": "Management field required.",
  "cod10004": "Cargo field required.",
  "cod10005": "Address field required.",
  "cod10006": "Date and hour field required.",
  "cod10007": "Email field required.",
  "cod10008": "MOP permit number field required.",
  "cod10009": "MOP permit file field required.",
  "cod10010": "Bodyguard field required.",
  "cod10011": "Vehicle type field required.",
  "cod10012": "Invalid email format.",
  "cod10013": "The hour and date cannot be set before TODAY at",
  "cod10014": "The hour and date cannot be superior to 24 hours from the actual time.",
  "cod10015": "Cargo field cannot be bigger than 128 characters.",
  "cod10016": "MOP permit number field cannot be bigger than 64 characters.",
  "cod10017": "Comments field cannot be bigger than 1024 characters.",
  "cod10018": "Email field cannot be bigger than 128 characters.",
  "codTag100": "This item already exists.",
  "codItem100": "This item already exists.",
  "codItem104": "This item already exists.",
  "codItem304": "This item already exists.",
  "codItem303": "This item already exists.",
  "codList100": "This list already exists.",
  "codList104": "This list already exists.",
  "codGroup500": "Please, add a name for the group.",
  "codGroup501": "Invalid group name (' cannot be supported).",
  "codGroup1001": "The group was not found in the database.",
  "codGroup1900": "Please, add the email list.",
  "codGroup1901": "Invalid list of emails (each email has to be separated by a ,).",
  "codGroup503": "The alias already exists.",
  "codGroup504": "The alias already exists but in a deactivated entity.",
  "codGroup12000": "It is required to indicate if it is a dynamic shift or not.",
  "codGroup13000": "Please, add the number of days.",
  "codGroup13001": "The number of days is out of range, it must be equal or bigger than 1.",
  "codGroup14000": "Please, add the schedule planification.",
  "codGroup14001": "The schedule planification has no valid format, it was indicated that its type is “work” but schedule was not indicated.",
  "codGroup15000": "Please, add the beginning of the shift date.",
  "codGroup16000": "Please, add the maximum time for the report to be sent.",
  "codGroup16001": "The maximum time for the report to be sent is out of range, it must be equal or bigger than 1.",
  "codGroup17000": "Please, add the maximum time for the realization of the evaluation after the beginning of the shift.",
  "codGroup17001": "The maximum time for the realization of the evaluation after the established times it out of range, it must be equal or bigger than 1.",
  "codGroup18000": "Please, add the maximum time to complete the evaluation before the beginning of the shift.",
  "codGroup18001": "The maximum time given to complete the evaluation after the established time is out of range, it must be equal or bigger to 1.",
  "codGroup14002": "The schedule planification has an invalid format, it should at least contain a shift type “work”.",
  "codGroup18002": "The maximum time to complete the evaluation before the established time cannot be less than the maximum time given to send the report.",
  "cod18102": "The shift group does not exist.",
  "cod11001": "Invalid date format somewhere in the field. Valid format dd/mm/yyyy.",
  "cod1503": "The role to manage the deviations cannot be assigned because the user has no role assigned to see the deviations.",
  "codTask18200": "You must complete this field to close the deviation.",
  "cod605": "It is not possible to complete this action because you have no sufficient permits to edit this type of users, to complete this task you need a user with more elevated permits",
  "cod606": "It is not possible to complete this action because you have no sufficient permits to edit this type of users, to complete this task you need a user with more elevated permits",
  "cod1504": "It is not possible to complete this action because you have no sufficient permits to edit this type of users, to complete this task you need a user with more elevated permits",
  "cod604": "Please, add at least one item for each one of the categories",
  "apiErrorForm": "An error has occurred, try again.",
  "apiError": "An error has occurred, try again",
  "apiError500": "An error has occurred, try again",
  "noData": "An error has occurred, try again",
  "noSetting": "No setting",
  "cod607": "Cannot assign more than one item per category",
  "noAuthorization": "No authorization",
  "cod5200": "You have uploaded an unsupported file format. Please use one of these: {list-extensions}",
  "noRootAccess": "It is not possible to perform this action because you do not have sufficient permissions to download the file.",
  "invalidFileFormat": "The file format is not valid; it must be an Excel file.",
  "serviceUnavailable": "Service unavailable. Please try again later.",
  "noValidAssignations": "The file did not contain any valid assignments. Process canceled."
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/error.js